import React, { useState } from 'react';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { fetchWrapper, getChannelIdFromSettingsURL, toastWrapper } from '@/_helpers';
import { AiOutlineCopy } from 'react-icons/ai';
import { VscLoading } from 'react-icons/vsc';
import { useHistory } from 'react-router-dom';
import { showConfirmationAlert } from './alerts';
import { connect } from 'react-redux';

const CopyExistingForm = React.memo(({ teamId, form, currUser }) => {
    const history = useHistory();
    const [isBusy, setIsBusy] = useState(false);
    const channelId = getChannelIdFromSettingsURL();

    const copyExistingForm = async () => {
        try {
            const result = await showConfirmationAlert('Are you sure you want to copy this form?');
            if (!result.isConfirmed) return;
            if (!form?._id || !form?.name || isBusy) return;
            setIsBusy(true);
            const formData = {
                team: teamId,
                chatroom: channelId,
            };
            const response = await fetchWrapper.post(`forms/${form._id}/copy`, formData);
            if (response && response._id) {
                const targetUrl = teamId
                    ? `/form-library/edit/${response._id}`
                    : `/master-form-library/edit/${response._id}`;

                history.push(targetUrl);
            }
        } catch (err) {
            console.error('Error creating form:', err);
            toastWrapper.error(err?.message || 'Something went wrong while creating form');
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <BootstrapToolTip text="Copy Form">
            <span onClick={copyExistingForm} style={{ cursor: 'pointer' }}>
                {isBusy ? <VscLoading className="spin" /> : <AiOutlineCopy className="icon" />}
            </span>
        </BootstrapToolTip>
    );
});

const mapStateToProps = (state) => ({
    currUser: state.user.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CopyExistingForm);
